import React, { useContext } from 'react';
import classNames from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { SectionProps } from '../utils/SectionProps';
import SectionHeader from '../components/sections/partials/SectionHeader';
import Button from '../components/elements/Button';
import { AuthContext } from '../context/AuthContext';

const propTypes = {
  ...SectionProps.types
};

const defaultProps = {
  ...SectionProps.defaults
};

const Account = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor
}) => {
  const history = useHistory();
  const { logout } = useContext(AuthContext);

  const outerClasses = classNames(
    'signin section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'signin-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const sectionHeader = {
    title: 'Your Exanta account',
    paragraph: 'You are signed in and ready to access your protected resources.'
  };

  const handleLogout = () => {
    logout();
    history.push('/');
  };

  return (
    <section className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader tag="h1" data={sectionHeader} className="center-content" />
          <div className="tiles-wrap">
            <div className="tiles-item">
              <div className="tiles-item-inner has-shadow">
                <div className="mb-16">
                  <Button tag={Link} to="/feedback" color="primary" wide>
                    Fill Out Feedback Form
                  </Button>
                </div>
                <div className="mb-16">
                  <Button tag={Link} to="/download" color="primary" wide>
                    Go to Download
                  </Button>
                </div>
                <Button color="dark" wide onClick={handleLogout}>
                  Logout
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Account.propTypes = propTypes;
Account.defaultProps = defaultProps;

export default Account;
